export function getPartnerPointKey(partner: {
  title: string
  icon: string
  lend?: { multiplier?: number }
  deposit?: { multiplier?: number }
  collateral?: { multiplier?: number }
}): string {
  const lendMultiplier = partner.lend?.multiplier ?? 'none'
  const depositMultiplier = partner.deposit?.multiplier ?? 'none'
  const collateralMultiplier = partner.collateral?.multiplier ?? 'none'
  const actions =
    `${partner.lend ? 'lend' : ''}${partner.deposit ? 'deposit' : ''}${partner.collateral ? 'collateral' : ''}` ||
    'none'
  return `${partner.title}-${lendMultiplier}-${depositMultiplier}-${collateralMultiplier}-${actions}`
}
